// extracted by mini-css-extract-plugin
export default {"actions":"style_actions__r3TnC","remove":"style_remove__BbuH5"};